import { Component, computed, EventEmitter, Output, Signal, signal, ViewChild, WritableSignal } from '@angular/core';
import { ModalComponent } from '../../modal/modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { SharedService } from 'src/app/services/shared.service';
import { Color, Colors } from 'src/app/models/types/Product/Product.type';
import { AssetComponent } from '../../asset/asset.component';
import { SharedModule } from 'src/app/modules/shared.module';

@Component({
  selector: 'app-color-list-modal',
  imports: [
    ModalComponent,
    SharedModule
  ],
  templateUrl: './color-list-modal.component.html',
  styleUrl: './color-list-modal.component.scss'
})
export class ColorListModalComponent {

  @ViewChild('modal', { static: false }) modal!: ModalComponent;

  @Output('handleSelectColor') handleSelectColor: EventEmitter<Color> = new EventEmitter();

  private _colorList: WritableSignal<Colors> = signal([]);
  protected colorList: Signal<Colors> = computed(() => this._colorList());

  protected selectedColor: WritableSignal<Color | null> = signal(null);
  protected disabledConfirm: Signal<boolean> = computed(() => !this.selectedColor());

  constructor(
    public sharedService: SharedService
  ) { }

  openModal(colorList: Colors) {
    this._colorList.set(colorList);
    this.modal.buildModal(() => this.handleClose(), 'lg');
  }

  handleConfirm() {
    let color = this.selectedColor();
    if (color) {
      this.handleSelectColor.emit(color);
    }
    this.handleClose()
  }

  private handleClose() {
    this.modal.dismiss();
  }
}
